import { render } from "./AddRuh.vue?vue&type=template&id=22a49ccd"
import script from "./AddRuh.vue?vue&type=script&lang=js"
export * from "./AddRuh.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\pwa-tahlil\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__